import { SecurityScorecardDataState } from '@pages/executive-reports/components/executive-reports-tabs/security-scorecard-report/store/states/security-scorecard.state';

export const securityScorecardStates = [SecurityScorecardDataState];
